import { Box, Skeleton, SkeletonBox, useResponsive } from '@bitrise/bitkit';

type BuildListItemSkeletonProps = {
  active: boolean;
  canRunBuild: boolean;
  showAppInfo: boolean;
};
const BuildItemSkeleton = ({ active, canRunBuild, showAppInfo }: BuildListItemSkeletonProps): JSX.Element => {
  const { isMobile } = useResponsive();

  if (!isMobile) {
    return (
      <Skeleton isActive={active} display="flex" borderRadius="8" overflow="hidden" marginTop="24">
        <SkeletonBox height="auto" flexShrink="0" width="8" backgroundColor="neutral.90" />
        <Box display="flex" flexDirection="column" flexGrow={1}>
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
            gap="12"
            borderBottom="1px solid"
            borderBottomColor="neutral.93"
          >
            <Box display="flex" padding="12" gap="12" alignItems="center" overflow="hidden">
              <SkeletonBox height="24px" width="24px" borderRadius="4" />
              {showAppInfo ? (
                <>
                  <SkeletonBox height="40px" width="40px" borderRadius="4" />
                  <Box display="flex" gap="4" flexDirection="column" flexGrow={1}>
                    <SkeletonBox height="22px" width="128px" />
                    <SkeletonBox height="18px" width="350px" />
                  </Box>
                </>
              ) : (
                <SkeletonBox height="22px" width="128px" />
              )}
            </Box>
            {canRunBuild ? (
              <Box display="flex" paddingRight="12" justifyContent="flex-end" flexGrow={1}>
                <SkeletonBox height="24px" width="70px" borderRadius="4" />
              </Box>
            ) : null}
          </Box>
          <Box display="flex" justifyContent="space-between" alignItems="center" gap="12">
            <Box display="flex" gap="12">
              <SkeletonBox height="38px" width="225px" />
              <Box display="flex" paddingLeft="12" paddingTop="8" paddingBottom="10" paddingRight="12">
                <SkeletonBox height="20px" width="120px" />
              </Box>
            </Box>
            <Box
              display="flex"
              justifyContent="flex-end"
              paddingLeft="12"
              paddingTop="8"
              paddingBottom="10"
              paddingRight="12"
              gap="12"
            >
              <SkeletonBox height="20px" width="72px" />
              <SkeletonBox height="20px" width="64px" />
              <SkeletonBox height="20px" width="64px" />
              <SkeletonBox height="20px" width="64px" />
            </Box>
          </Box>
        </Box>
      </Skeleton>
    );
  }

  return (
    <Skeleton isActive={active} display="flex" borderRadius="8" overflow="hidden" marginTop="24">
      <SkeletonBox height="auto" flexShrink="0" width="8" backgroundColor="neutral.90" />
      <Box display="flex" flexDirection="column" width="100%">
        <Box display="flex" flexDirection="column" borderBottom="1px solid" borderBottomColor="neutral.93">
          <Box display="flex" alignItems="center" padding="12" gap="12">
            <SkeletonBox height="24px" width="24px" borderRadius="4" />
            {showAppInfo ? (
              <>
                <SkeletonBox height="40px" width="40px" borderRadius="4" />
                <Box display="flex" flexDirection="column" gap="2">
                  <SkeletonBox height="22px" width="94px" />
                  <SkeletonBox height="18px" width="64px" />
                </Box>
              </>
            ) : (
              <SkeletonBox height="22px" width="94px" />
            )}
          </Box>
          <Box display="flex" paddingX="12" paddingY="8" borderTop="1px solid" borderTopColor="neutral.93">
            <SkeletonBox height="16px" width="264px" />
          </Box>
        </Box>
        <Box display="flex" flexDirection="column">
          <Box display="flex" flexDirection="column" width="100%">
            <SkeletonBox height="38px" width="100%" />
            <Box display="flex" paddingX="12" paddingY="8">
              <SkeletonBox height="20px" width="120px" />
            </Box>
          </Box>
          <Box
            display="flex"
            borderTop="1px solid"
            borderTopColor="neutral.93"
            paddingLeft="12"
            paddingTop="8"
            paddingBottom="10"
            paddingRight="12"
            gap="12"
            width="100%"
          >
            <SkeletonBox height="20px" maxWidth="72px" flexGrow={1} />
            <SkeletonBox height="20px" maxWidth="64px" flexGrow={1} />
            <SkeletonBox height="20px" maxWidth="64px" flexGrow={1} />
            <SkeletonBox height="20px" maxWidth="64px" flexGrow={1} />
          </Box>
        </Box>
      </Box>
    </Skeleton>
  );
};

export default BuildItemSkeleton;
